'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _defaultVoucherImage = require('assets/img/voucher/defaultVoucherImage.jpg');

var _defaultVoucherImage2 = _interopRequireDefault(_defaultVoucherImage);

var _components = require('components');

var _Home = require('../Home');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DetailBannerInfo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DetailBannerInfo, _Component);

  function DetailBannerInfo(props) {
    (0, _classCallCheck3.default)(this, DetailBannerInfo);
    return (0, _possibleConstructorReturn3.default)(this, (DetailBannerInfo.__proto__ || (0, _getPrototypeOf2.default)(DetailBannerInfo)).call(this, props));
  }

  (0, _createClass3.default)(DetailBannerInfo, [{
    key: 'renderContent',
    value: function renderContent() {
      var styles = require('./Voucher.scss');
      return _react2.default.createElement(
        'div',
        {
          id: 'voucherDetail',
          className: styles.voucherDetail,
          ref: 'voucherDetail'
        },
        _react2.default.createElement(
          'div',
          { className: styles.modalBody },
          _react2.default.createElement(
            'div',
            { className: styles.image },
            _react2.default.createElement('i', {
              className: 'fa fa-angle-left',
              onClick: this.props.history.goBack
            }),
            _react2.default.createElement('img', {
              src: 'https://minio.lookme.vn/banners/detail_banner__Gel_rua_tay.gif' || _defaultVoucherImage2.default,
              alt: 'H\xECnh avatar'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.primaryInfo },
            _react2.default.createElement(
              'div',
              { className: styles.info },
              _react2.default.createElement(
                'div',
                { className: styles.title },
                'T\u1EB7ng 1 chai gel r\u1EEDa tay 50ml'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.description },
              _react2.default.createElement(
                'h2',
                { className: styles.lmTitle },
                ' \u0110i\u1EC1u ki\u1EC7n:'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.content },
                '\n                \uD83D\uDC8CM\u1ED7i kh\xE1ch h\xE0ng booking d\u1ECBch v\u1EE5 l\xE0m \u0111\u1EB9p tr\xEAn Lookme v\xE0 s\u1EED d\u1EE5ng th\xE0nh c\xF4ng s\u1EBD \u0111\u01B0\u1EE3c t\u1EB7ng ngay m\u1ED9t chai \u201CGel R\u1EEDa Tay\u201D 50ml\n                \uD83D\uDC8CM\u1ED7i kh\xE1ch h\xE0ng ch\u1EC9 \u0111\u01B0\u1EE3c t\u1EB7ng 1 l\u1EA7n cho b\u1EA5t k\u1EF3 d\u1ECBch v\u1EE5 l\xE0m \u0111\u1EB9p n\xE0o\n                \uD83D\uDC8CCh\u01B0\u01A1ng tr\xECnh s\u1EBD k\u1EBFt th\xFAc khi \u0111\xE3 t\u1EB7ng h\u1EBFt \u201Cgel r\u1EEDa tay\u201D\n                \uD83D\uDC8C\xC1p d\u1EE5ng t\u1EA1i khu v\u1EF1c Th\xE0nh ph\u1ED1 H\u1ED3 Ch\xED Minh\n                \uD83D\uDC8CB\u1EAFt \u0111\u1EA7u: t\u1EEB ng\xE0y 01/03/2020 \u0111\u1EBFn 31/03/2020\n                '
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.condition },
              _react2.default.createElement(
                'h2',
                { className: styles.lmTitle },
                'H\xECnh th\u1EE9c nh\u1EADn Gel r\u1EEDa tay:'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.content },
                '\n              \uD83C\uDF38Kh\xE1ch h\xE0ng s\u1EBD nh\u1EADn \u201CGel R\u1EEDa Tay\u201D t\u1EA1i spa sau khi tr\u1EA3i nghi\u1EC7m d\u1ECBch v\u1EE5 m\xE0 kh\xE1ch h\xE0ng \u0111\xE3 booking tr\xEAn h\u1EC7 th\u1ED1ng Lookme.\n              '
              )
            )
          )
        ),
        _react2.default.createElement(_Home.Promotion, { history: this.props.history, title: 'Ưu đãi hiện hành' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var bannerData = {
        image: 'https://minio.lookme.vn/banners/detail_banner__Gel_rua_tay.gif',
        name: 'Tặng gel rửa tay 50ml',
        description: 'Khách hàng sẽ nhận “Gel Rửa Tay” tại spa sau khi trải nghiệm dịch vụ mà khách hàng đã booking trên hệ thống Lookme'
      };
      return _react2.default.createElement(
        'div',
        { style: { display: 'block', width: '100%', height: '100%' } },
        _react2.default.createElement(_components.HelmetSEO, { seoProps: bannerData }),
        this.renderContent()
      );
    }
  }]);
  return DetailBannerInfo;
}(_react.Component), _class.propTypes = {
  params: _react.PropTypes.object,
  user: _react.PropTypes.object,
  history: _react.PropTypes.object,
  location: _react.PropTypes.object
}, _temp);
exports.default = DetailBannerInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Voucher/DetailBannerInfo.js
// module id = 1639
// module chunks = 0